import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faSignIn} from '@fortawesome/pro-solid-svg-icons';
import type {IGroupUser} from '@netx/core-system-groups/schema';
import {canLoginAsUser} from '../enablers';
import {UserActionLabel} from '../locales';
import {USER_EVENT} from './constants';

export const userActionLoginAsIcon = faSignIn;

/**
 * Login as user
 * @param params
 * @returns Action
 */
export const userActionLoginAs = (
	user?: IGroupUser,
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'user-login-as',
	cb: () => dispatcher.trigger(USER_EVENT.LOGIN_AS, user),
	enableTest: () => canLoginAsUser(user),
	icon: userActionLoginAsIcon,
	get label() {
		return UserActionLabel.LOGIN_AS;
	},
	...params,
});

export default userActionLoginAs;
